import { clearAppLocalforageData } from '../clearAppLocalforageData';

import { ThunkMiddleware, UnknownAction } from '@reduxjs/toolkit';
import { PersistPartial } from 'redux-persist/es/persistReducer';

const authMiddleware: ThunkMiddleware<PersistPartial, UnknownAction, null> =
  () => (next) => (action) => {
    try {
      const result = next(action);

      if ((action as any).type === 'auth/sessionExpired') {
        void clearAppLocalforageData();
      }

      return result;
    } catch (err) {
      /* empty */
    }
  };

export default authMiddleware;
